<template>
  <div class="dataBox">
    <div class="tools">
      <div class="tools-left">
        <div class="number">已选择 {{ selectList.length }} 条记录</div>
        <el-button
          :disabled="!selectSubmitList.length"
          size="mini"
          type="danger"
          class="btn "
          :class="{submitBtn: selectSubmitList.length}"
          @click="onBatchSign"
          >批量签署</el-button
        >
      </div>
      <div class="tools-right"></div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%; margin-bottom: 10px"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
      @selection-change="handleSelectionChange"
    >
      <template slot="empty">
        <img
          class="data-pic"
          src="../../../../../assets/images/H5/null.png"
          alt
        />
        <br />暂无数据
      </template>
      <el-table-column type="selection" width="55" :selectable="(row) => {return !row.batchSigning}"> </el-table-column>
      <el-table-column prop="code" label="合同编号"></el-table-column>
      <el-table-column prop="name" label="合同名称"></el-table-column>
      <el-table-column label="发起方">
        <template slot-scope="scope">
          <span>{{
            scope.row && scope.row.contractUser && scope.row.contractUser.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="签署批次">
        <template slot-scope="scope">
          <span>{{ scope.row.batchNo ? scope.row.batchNo : '-' }}</span>
          <span v-if="scope.row.batchSigning" class="red">（批量签署中）</span>
        </template>
      </el-table-column>
      <el-table-column prop="signStartTime" label="签署操作时间"></el-table-column>
      <el-table-column label="操作" width="257px">
        <template slot-scope="scope">
          <div class="handlerBoxCenter">
            <div class="cursorPointer" @click="toSignTrue(scope.row, '1')" v-if="!scope.row.batchSigning">
              <span class="iconDscp">重新签署</span>
            </div>
            <!-- <div
              class="cursorPointer"
              v-if="judgeShowReject(scope.row)"
              @click="toReject(scope.row, '1')"
            >
              <span class="iconDscp">拒签</span>
            </div> -->
            <div class="cursorPointer" @click="toDetail(scope.row)">
              <span class="iconDscp">详情</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      tableData: [],

      selectList: [], //  已选
      selectSubmitList: [], // 可提交
    };
  },
  mounted() {},
  methods: {
    setData(data) {
      this.tableData = data;
    },
    toSignTrue(row, flag) {
      this.$emit("toSignTrue", { data: row, flag: flag });
    },
    getTaskId(data, flag, all) {
      if (data && data.length) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].actionCode === flag) {
            if (all) {
              return data[i];
            } else {
              return data[i].taskId;
            }
          }
        }
      }
      return false;
    },
    judgeShowReject(row) {
      let SignTask = this.getTaskId(row.taskList, "SIGN", true);

      if (SignTask) {
        if (row.contractUser.userId == SignTask.userId) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    toReject(row, flag) {
      this.$emit("toReject", row);
    },
    toDetail(row) {
      this.$emit("toDetail", row);
    },

    // 选择
    handleSelectionChange(val) {
      let list = [];
      if (val.length) {
        val.forEach((item) => {
          list.push({
            id: item.id,
            name: item.name,
            code: item.code,
            userId: item.userId,
            debtorName: item.debtorName,
            taskId: this.getTaskId(item.taskList, "SIGN"),
            currUserSealParam: item.currUserSealParam ? JSON.parse(item.currUserSealParam) : null
          });
        });
      }
      this.selectList = val;
      this.selectSubmitList = list;
      // sessionStorage.setItem('SignMediateBatch', JSON.stringify(list))
    },

    // 批量签署按钮
    onBatchSign() {
      this.$emit("onBatchSign", this.selectSubmitList);
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
.tools {
  display: flex;
  align-items: center;
  // margin-bottom: 16px;
  margin: 32px 0 16px 0;
  .tools-left {
    flex: 1;
    display: flex;
    align-items: center;
    .number {
      font-size: 14px;
      font-weight: 400;
      color: #bdbdbd;
      line-height: 20px;
      margin-right: 12px;
    }
  }
  .tools-right {
    display: flex;
    align-items: center;
  }
}

.btn {
  width: 100px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  padding: 0;
}
.saveBtn {
  border: 1px solid #e9e9e9;
  background: #ffffff;
  color: #bdbdbd;
}
.submitBtn {
  color: #ffffff;
  background: #db1c1b;
}

.red {
    color: #db1c1b;
}
</style>
  